import { Component, inject } from '@angular/core';
import { AccessState } from '@core/frontend-shared';
import { Store } from '@ngxs/store';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'pflegetheke-admin-home',
    template: `
	@if (userData$|async; as userData) {
	  <h2>Willkommen zurück,<br> <b>{{userData?.firstName}} {{userData?.lastName}}</b>!</h2>
	}
	`,
    styles: [`
	:host {display:flex;justify-content:center;align-items:center;}
	h2 { opacity:30%; font-size:42px; }
  `],
    imports: [AsyncPipe]
})
export class HomeComponent {
	userData$ = inject(Store).select(AccessState.accessData('user')) 

}
